import React from "react";
import { RefreshCw } from "lucide-react";
import { useVersionCheck } from "../hooks/useVersionCheck";
import { useLocalization } from "../contexts/LocalizationContext";

const UpdateBanner: React.FC = () => {
  const { updateAvailable, applyUpdate } = useVersionCheck(60_000);
  const { language } = useLocalization();

  if (!updateAvailable) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-[9999] bg-indigo-600 text-white px-4 py-2.5 flex items-center justify-center gap-3 shadow-lg animate-slide-down">
      <RefreshCw className="w-4 h-4" />
      <span className="text-sm font-medium">
        {language === "fr"
          ? "Une nouvelle version est disponible."
          : "A new version is available."}
      </span>
      <button
        onClick={applyUpdate}
        className="bg-white text-indigo-700 px-4 py-1 rounded-lg text-sm font-bold hover:bg-indigo-50 transition-colors"
      >
        {language === "fr" ? "Actualiser" : "Refresh"}
      </button>
    </div>
  );
};

export default UpdateBanner;
